import query from "../../server/constants.api";
import useFetch from "../../server/useFetch";
import { WidgetCard } from "../Global/Atomics/WidgetCard";
import CustomIcon from "../Global/Icons/CustomIcon";
import { RadarChartComponent } from "../Global/Charts/RadarChartComponent";
import Spinner from "../Global/Atomics/Spinner";
import { Text } from '../Global/Atomics/Text';
import Theme from '../../styles/Theme/Theme';

export const SlaMatchingWidget = () => {
    const { data, isLoading } = useFetch(query.path.verticalSla, 'getVerticalSla');
    const radarData = [];
    const iconsIds = [];
    if(!isLoading){
        const finalData = data?.data;
        Object.keys(finalData).forEach((key, index)=> {
            radarData.push({
                name: finalData[key].Label,
                sla: finalData[key].SLA,
                sla_obj: finalData[key].SLA_OBJ,
                sla_top: 100,
            })

            iconsIds.push({
                icon: finalData[key].Icon
            })
        })
    }

    
    return(
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} justifyContent='space-between' margin={Theme.spacing.videowall.xxs}>
            <div style={{display: "flex", alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '48px'}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <CustomIcon icon={'HoldingHands'} iconSize='lg' color={Theme.color['teal-4']}/>
                    <Text color={Theme.color['coolgray-12']} marginLeft={Theme.spacing.videowall.xs} fontSize='text_xxl' fontWeight={Theme.typography.weight.medium}>SLA Matching</Text>
                </div>
                <Text color={Theme.color['coolgray-10']} fontSize='text_lg' fontWeight={Theme.typography.weight.regular}>Last 7 days</Text>
            </div>
            {!isLoading ?
            <RadarChartComponent data={radarData} icons={iconsIds}/>
            : <div style={{height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}><Spinner stroke="green"/></div>
            }
        </WidgetCard>
    )
};